export const Colors = [
  // 1
  '#FFBFBF',
  '#FED187',
  '#E9EC7A',
  '#80ED99',
  '#7AE5EC',
  '#95C5FE',
  '#DABFFF',

  // 2
  '#F69393',
  '#F7B578',
  '#DBDF21',
  '#80E2B3',
  '#21D4DF',
  '#6DAEFA',
  '#BC99EC',

  // 3
  '#FC7070',
  '#FEB237',
  '#BABE0E',
  '#2BCF80',
  '#1CBFC9',
  '#489CFF',
  '#8D6CF5',

  // 4
  '#F44444',
  '#FF8B02',
  '#82A747',
  '#469B72',
  '#41ABB2',
  '#5191DD',
  '#7E69C0',

  // 5
  '#FF886D',
  '#FEEB87',
  '#C8E9A0',
  '#80E2C5',
  '#7FDEFF',
  '#95ACFE',
  '#EA9CF1',

  // 6
  '#FE6737',
  '#FFDC23',
  '#A3F7B5',
  '#4ED3AB',
  '#58CBF3',
  '#6C8DFF',
  '#DC5AE8',

  // 7
  '#D1664E',
  '#E3BF00',
  '#598B2C',
  '#2EB58D',
  '#3DA5C9',
  '#4F70E8',
  '#9A3FA2',

  // 8
  '#F2F2F2',
  '#E7E7E7',
  '#D7D4D4',
  '#C5C2C2',
  '#D5D9E5',
  '#C5C7D6',
  '#A7AABB',
]
